import { TFunction } from 'i18next'
import i18n from '.'

export namespace i18nTranslationHelper {
  export enum Prefix {
    VALIDATIONS = 'system.validations',
    PAGES = 'pages',
    INPUT = 'components.input',
    FIELDS = 'system.entities.fields',
    COMPONENTS = 'components',
    ENTITIES = 'system.entities',
    ENUMS = 'system.entities.enums'
  }

  let instance: typeof i18n
  let validations: TFunction<'translation', Prefix.VALIDATIONS> | ((key: string) => string)
  let pages: TFunction<'translation', Prefix.PAGES> | ((key: string) => string)
  let input: TFunction<'translation', Prefix.INPUT> | ((key: string) => string)
  let fields: TFunction<'translation', Prefix.FIELDS> | ((key: string) => string)
  let components: TFunction<'translation', Prefix.COMPONENTS> | ((key: string) => string)
  let entities: TFunction<'translation', Prefix.ENTITIES> | ((key: string) => string)
  let enums: TFunction<'translation', Prefix.ENUMS> | ((key: string) => string)

  export const getI18nInstance = () => {
    if (!instance) {
      console.log('i18n instance not set')
      return
    }
    return instance
  }

  export const init = (i18nInstance: typeof i18n) => {
    if (!instance) {
      instance = i18nInstance
      validations = getTNamespace(Prefix.VALIDATIONS)
      input = getTNamespace(Prefix.INPUT)
      fields = getTNamespace(Prefix.FIELDS)
      pages = getTNamespace(Prefix.PAGES)
      components = getTNamespace(Prefix.COMPONENTS)
      entities = getTNamespace(Prefix.ENTITIES)
      enums = getTNamespace(Prefix.ENUMS)
    }
  }

  export const getCurrentLanguage = () => instance.language

  export const getAllLanguages = () => Object.keys(instance.store.data)

  export const getTNamespace = (namespace: string) => instance.getFixedT(null, null, namespace)

  export const getTValidations = (
    translationKey: string,
    ...params: { [key: string]: string }[]
  ): string => validations(translationKey, ...(params as unknown as string[]))

  export const getTPage = (
    translationKey: string,
    ...params: { [key: string]: string }[]
  ): string => pages(translationKey, ...(params as unknown as string[]))

  export const getTInput = (
    translationKey: string,
    ...params: { [key: string]: string }[]
  ): string => input(translationKey, ...(params as unknown as string[]))

  export const getTEntitiesFields = (
    translationKey: string,
    ...params: { [key: string]: string }[]
  ): string => fields(translationKey, ...(params as unknown as string[]))

  export const getTComponents = (
    translationKey: string,
    ...params: { [key: string]: string }[]
  ): string => components(translationKey, ...(params as unknown as string[]))

  export const getTEntities = (
    translationKey: string,
    ...params: { [key: string]: string }[]
  ): string => entities(translationKey, ...(params as unknown as string[]))

  export const getTEnums = (
    translationKey: string,
    ...params: { [key: string]: string }[]
  ): string => enums(translationKey, ...(params as unknown as string[]))

  export const changeLanguage = (language: string) => {
    return new Promise<void>((resolve, reject) => {
      instance.changeLanguage(language, err => {
        if (err) {
          reject(err)
        } else {
          resolve()
        }
      })
    })
  }

  export const getTObjects = (key: string): string | object => {
    if (!instance) {
      console.warn('i18n instance not set')
      return key
    }
    return instance.t(key, { returnObjects: true })
  }
}
